export enum LorenAlarmsSorting {
  ASCENDING = "ascending",
  DESCENDING = "descending",
}
